import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Waves, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState("");

  useEffect(() => { api.get("/settings").then((r) => setLogo(r.data.logo || "")).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("salitre_token", data.token);
      toast.success("Bienvenido");
      navigate("/admin/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#075985] px-4"
      style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #0369A1 0%, #075985 45%, #0C4A6E 100%)" }}>
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl md:p-10">
        <div className="mb-8 flex items-center gap-2.5 text-[#075985]">
          {logo ? <img src={imgUrl(logo)} alt="" className="h-14 w-auto object-contain" /> : <><Waves className="h-7 w-7" /><span className="font-display text-2xl font-bold">Chiringuito Salitre</span></>}
        </div>
        <h1 className="font-display text-3xl font-bold text-[#1C1917]">Panel de administración</h1>
        <p className="mt-1.5 text-sm text-[#57534E]">Accede para gestionar tus cartas.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email" className="text-sm font-semibold">Correo electrónico</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="tucorreo@gmail.com" required className="mt-1.5 h-11" />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-semibold">Contraseña</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required className="mt-1.5 h-11" />
          </div>
          <button data-testid="login-submit-button" disabled={loading}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#EA580C] font-bold text-white transition-all hover:bg-[#C2410C] disabled:opacity-60">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4" /> Entrar</>}
          </button>
        </form>
        <button onClick={() => navigate("/")} className="mt-6 w-full text-center text-sm text-[#78716C] hover:text-[#0369A1]">
          ← Volver a la web
        </button>
      </div>
    </div>
  );
}
